module.exports = __webpack_public_path__ + "files/b6e2403cd290ec46649b5993039002f1.png";